import { DomHelper } from '../../utlis/DomHelper'
import { ArrowSection } from './ArrowSection'
import { ImageSection } from './ImageSection'
import { LineSection } from './LineSection'
import { OptionsSection } from './OptionsSection'
import { RichTextSection } from './RIchTextSection'
import { SectionBase } from './SectionBase'
import { TextBoxSection } from './TextBoxSection'

export interface Section {
  isLocked: boolean
  row: number
  col: number
  height: number
  width: number
  rowCount: number
  colCount: number
  name: string
  type: SectionType
  id: string
  selected: boolean
  x?: number
  y?: number
  propInfo?: PropInfo[]
  options?: OptionItem[] | TextBoxOption[]
  value?: any
  textContent: string
}

export interface OptionItem {
  label: string
  labelMaxWidth?:string
  isCorrect: boolean
  isOptional?:boolean
  showLabel: boolean
}

export interface TextBoxOption {
  label: string;
  labelMaxWidth?:string
  correctValue: string;
  optionalValue?:string;
  minimumOptionalValue?:number;
  showLabel: boolean;
}

export type SectionType = 'text' | 'image' | 'richText' | 'option' | 'tags' | 'textbox' | 'line' | 'arrow' | 'rectangle';

export const SectionTypes = {
  text: 'text',
  image: 'image',
  option: 'option',
  richText: 'richText',
  textbox: 'textbox',
  line: 'line',
  arrow: 'arrow',
  rectangle: 'rectangle'
}

export interface IDropDownOption {
  label: string
  value: string
  selected?: boolean
}

export interface PropInfo {
  name: string
  label: string
  binding: string
  inputType: 'text' | 'number' | 'color' | 'gradientcolor' | 'dropdown' | 'file' | 'multiSelect'  |'tags' |  'none' | 'multiOptionTextBox' | 'audio' | 'decimal'
  value: any
  hidden?: boolean
  isReadOnly?: boolean
  options?: IDropDownOption[] | OptionItem[] | TextBoxOption[]
}

export class SectionFactory {
  static getSectionByType(section: Section) {
    switch (section.type) {
      case SectionTypes.image:
        return new ImageSection(section)
      case SectionTypes.rectangle:
      case SectionTypes.text:
        return new TextSection(section)
      case SectionTypes.option:
        return new OptionsSection(section)
      case SectionTypes.richText:
        return new RichTextSection(section)
      case SectionTypes.textbox:
        return new TextBoxSection(section)
      case SectionTypes.line:
        return new LineSection(section);
      case SectionTypes.arrow:
        return new ArrowSection(section);
    }
  }
  static createSectionElement() {
    const existingSections: string[] = Array.from(
      document.querySelectorAll('.layout-drag-item')
    ).map((el) => el.id)
    const div = document.createElement('div')
    div.tabIndex = -1
    div.classList.add('layout-drag-item')
    div.style.position = 'absolute'
    div.style.border = '1px solid #000'
    div.style.borderRadius = '4px'
    div.id = DomHelper.getId({ existing: existingSections })
    return div
  }
}

export class TextSection extends SectionBase {
  constructor(options: Section) {
    super(options)
  }
  clone() {
    return new TextSection(this.toJSON())
  }
  render(): HTMLDivElement {
    const parent = document.createElement('div')
    parent.classList.add('wrapper')
    const div = document.createElement('div')
    div.classList.add('section')
    div.classList.add('text-section')
    div.style.position = 'relative'
    // div.style.overflow = 'auto'
    div.textContent = this.textContent
    if (this.selected) {
      div.classList.add('selected')
    }
    parent.appendChild(div)
    return parent
  }
}


